/**
 * @description 多言語サイトかどうか判定
 */

export const existsMultiLanguage = () => {
  const multilangName = ['en', 'cn', 'tw', 'kr'];
  const locList = location.pathname.split('/');
  const reg = new RegExp('^(' + multilangName.join('|') + ')$');

  return locList.some((dir: string) => {
    return dir.match(reg);
  });
};
